import { HEADING_COLOR, type BlockComponentProps } from "./shared"

export function HeadingBlock({ content, resolved }: BlockComponentProps) {
  const text = (content?.text as string) ?? ""
  const level = Math.min(6, Math.max(1, (content?.level as number) ?? 2))
  if (!text) return null
  const Tag = `h${level}` as keyof JSX.IntrinsicElements
  const headingSectionClass = resolved.hasOverrides
    ? `px-4 @sm:px-6 @md:px-8 ${resolved.paddingClass || "py-4"} ${resolved.cornerClass} ${resolved.alignClass}`.trim()
    : "px-4 py-4 @sm:px-6 @md:px-8"
  return (
    <section className={headingSectionClass} style={resolved.sectionStyle}>
      <Tag
        className="font-bold tracking-tight"
        style={{ color: HEADING_COLOR }}
      >
        {text}
      </Tag>
    </section>
  )
}
